import { gql, useLazyQuery } from "@apollo/client";
import { Button, Form, Input, message, Typography } from "antd";
import { useHistory, useParams } from "react-router-dom";
import CreditCardInfo from "./CreditCardInfo";
import { useEffect } from "react";

const query = gql`
  query Vendor_PaymentPortalGetCCAuthorization($email: String!, $id: String!) {
    vendor_getCCAuthorization(email: $email, id: $id) {
      data
      error
    }
  }
`;

export default function PaymentPortal() {
  const { authKey } = useParams();
  const history = useHistory();
  const [doQuery, { data }] = useLazyQuery(query);
  const ccData = data?.vendor_getCCAuthorization?.data;
  useEffect(() => {
    if (!authKey) {
      message.error({
        key: "missing-auth-key",
        content:
          "This page requires an auth key. Please copy the link sent to you by email and try again.",
      });
      history.push("/");
    }
  }, [authKey, history]);
  return (
    <>
      {!ccData && (
        <div
          style={{
            position: "relative",
            height: "100vh",
            width: "100vw",
            backgroundImage: `linear-gradient(
          to right,
          rgba(156, 156, 156, 0.8),
          rgba(28, 255, 179, 0.849)),
          url(../img/gazeebo.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "top",
          }}
        >
          <div
            className="logo-box"
            onClick={() => history.push("/")}
            style={{ cursor: "pointer" }}
          >
            <img src="/img/logo-white.png" alt="Logo" className="logo" />
          </div>
          <div className="login-container">
            <Form
              autoComplete="on"
              onFinish={(fields) => {
                if (!fields.email) return alert("Missing email address");
                doQuery({
                  variables: { email: fields.email.toLowerCase(), id: authKey },
                });
              }}
            >
              <Typography.Title level={3}>Payment Portal</Typography.Title>
              <div className="sign-in__field-wrap">
                <label htmlFor="email">
                  Please enter the email address to which this link was sent:
                </label>
                <div style={{ height: 10 }}></div>
                <Form.Item
                  type="email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message:
                        "Please enter the email address that recieved this link!",
                    },
                    {
                      type: "email",
                      message: "Please enter a valid email address",
                    },
                  ]}
                >
                  <Input
                    placeholder="Email Address"
                    name="email"
                    type="email"
                    autoComplete="email"
                  />
                </Form.Item>
                {!!data?.vendor_getCCAuthorization?.error && (
                  <Typography.Text type="danger">
                    {data?.vendor_getCCAuthorization?.error}
                  </Typography.Text>
                )}
              </div>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      )}
      {!!ccData && <CreditCardInfo data={ccData} />}
    </>
  );
}
